import React from 'react';
import LoadAlertsWidget from './LoadAlertsWidget';

const ConditionalLoadAlertsWidget: React.FC = () => <LoadAlertsWidget />;

export default ConditionalLoadAlertsWidget;
